import { render, staticRenderFns } from "./ENJIBtn.vue?vue&type=template&id=8e195b46&scoped=true&"
import script from "./ENJIBtn.vue?vue&type=script&lang=js&"
export * from "./ENJIBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e195b46",
  null
  
)

export default component.exports